<template>
  <ModalLinkButton :title="$t('Viewing Information')" :content="viewingInfo"
                   class="ta-auction-viewing-information-link"/>
</template>

<script>
import auctionViewMixin from "@/mixins/auctionViewMixin";
import ModalLinkButton from "@/components/ModalLinkButton.vue";

export default {
  name: "AuctionViewingInformationLink",
  components: {ModalLinkButton},
  mixins: [auctionViewMixin],
}
</script>

<style lang="scss" scoped>
</style>
